import script from "./WatermarkOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./WatermarkOverlay.vue?vue&type=script&setup=true&lang=js"

import "./WatermarkOverlay.vue?vue&type=style&index=0&id=6431f80e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6431f80e"]])

export default __exports__